export enum TypeQuestion {
  'multiple choice' = 1,
  'only choice' = 2,
  'satisfaction' = 3
}
